// src/useIsMobile.js
import { useState, useEffect } from 'react';

// We'll use 768px as the breakpoint, just like in your CSS
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]); // Only re-run if the breakpoint prop changes

  return isMobile;
};

export default useIsMobile;